import React from "react";
import { PageContainter, PageHeading } from "./about";

const VideoGallery = () => {
  return (
    <PageContainter>
      <PageHeading>Video Gallery</PageHeading>
      No Videos Currently
    </PageContainter>
  );
};

export default VideoGallery;
